export default class Configuracao {
  constructor(id = null, chave = null, valor = null, descricao = null) {
    this.id = id
    this.chave = chave
    this.valor = valor
    this.descricao = descricao
  }
}
